import { createFileRoute, redirect } from "@tanstack/react-router";

/** Cart was part of the old contract create flow — send vendors to invoices. */
export const Route = createFileRoute("/vendor/contract/cart")({
	beforeLoad: () => {
		throw redirect({ to: "/vendor/invoices/create" });
	}
});
